module.exports = __webpack_public_path__ + "static/img/yorkton2.fb385fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/yorkton2.jpg
// module id = 154
// module chunks = 9